import styled from "styled-components";

const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  border: none;
  color: grey;
  background-color: #f8f8f9;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  font-family: "Montserrat", sans-serif;
  height: 45px;
  padding: 0 5px 0 5px;
  overflow-x: auto;
  overflow-y: hidden;
  p {
    white-space: nowrap;
    vertical-align: middle;
  }
`;

export default StyledDiv;
